import { Provider, TemplateRef, ViewChild, ViewChildDecorator, forwardRef } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Stellt Templates für "Views" bereit, die serviceübergreifend benötigt werden.
 * Z.B. um den "View" auf ein Content-Element in eine andere Portalkomponente
 * einzubetten.
 *
 * Wird in {@link ViewComponent} genutzt/angezeigt.
 *
 * <strong>Alle Implementierungen sollten ihr Template mittels Angular-Query
 * ({@link ViewChild}/{@link ViewChildDecorator}) mit dem Flag <code>{static: true}</code>
 * auflösen, damit das Template dort in "ngOnInit" definitiv aufgelöst ist.</strong>
 */
export abstract class IViewProvider {
    /**
     * Liefert das Template für den View.
     *
     * @param type der Typ des anzuzeigenden Inhaltes
     * @param multi true heißt, dass mehrere Instanzen des Inhaltes angezeigt werden sollen
     * @returns das Template für den View. Als Observable, da es ggf. erst nachgeladen werden muss.
     */
    abstract getView(type: string, multi?: boolean): Observable<TemplateRef<ViewParams>>;
}

/**
 * Die Templates müssen jeweils mindestens folgende Parameter im Outlet-Context unterstützen.
 * Es dürfen weitere Parameter unterstützt werden.
 */
export interface ViewParams {
    /** Die ID des anzuzeigenden Inhaltes. Im Falle von multi=true eine Liste von IDs. */
    id: string | string[];
}

// Siehe https://angular.io/docs/ts/latest/cookbook/dependency-injection.html#!#provideparent
export function provideViews(component: any) {
    return { provide: IViewProvider, useExisting: forwardRef(() => component) } as Provider;
}
